export const Variaveis = {
    urlServer: "https://comercial-server.samdoc.info" //"http://192.168.15.66"
}